module.exports = __webpack_public_path__ + "static/media/1.0f747c6e.jpg";